import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {IHistoryRecordViewModel} from "../../../../services/gaming-history/models/record/history-record-view-model.interface";
import {HistoryRecordDateContainerBox} from "./boxes/middle-section/date/history-record-date-container.box";
import {HistoryRecordCalendarBox} from "./boxes/middle-section/date/calendar/history-record-calendar.box";
import {HistoryRecordDateValueBox} from "./boxes/middle-section/date/value/history-record-date-value.box";
import {CyClass} from "../../../../../common/cy-classes";
import {HistoryRecordMiddleSectionBox} from "./boxes/middle-section/history-record-middle-section.box";
import {HistoryRecordSpecialMessageBox} from "./boxes/middle-section/special-message/history-record-special-message.box";
import {observer} from "mobx-react";

interface GamingHistoryRecordMiddleSectionComponentProps {
    record: IHistoryRecordViewModel;
}

export const GamingHistoryRecordContentMiddleSectionComponent = observer(
    class GamingHistoryRecordContentMiddleSectionComponent extends OrbitComponent<GamingHistoryRecordMiddleSectionComponentProps> {
        private _renderBigWinMessage() {
            if(this.props.record.bigWinMessage) {
                return (
                    <HistoryRecordSpecialMessageBox className={CyClass('cy-gaming-history-big-win-message')}>
                        {this.props.record.bigWinMessage}
                    </HistoryRecordSpecialMessageBox>
                );
            }

            return null;
        }

        private _renderFreePlayMessage() {
            if(this.props.record.freePlayMessage) {
                return (
                    <HistoryRecordSpecialMessageBox className={CyClass('cy-history-free-play-message')}>
                        {this.props.record.freePlayMessage}
                    </HistoryRecordSpecialMessageBox>
                );
            }

            return null;
        }
        
        render() {
            return (
                <HistoryRecordMiddleSectionBox>
                    <HistoryRecordDateContainerBox>
                        <HistoryRecordCalendarBox/>
                        <HistoryRecordDateValueBox className={CyClass('cy-gaming-history-play-date')}>
                            {this.props.record.date}
                        </HistoryRecordDateValueBox>
                    </HistoryRecordDateContainerBox>

                    {this._renderBigWinMessage()}
                    {this._renderFreePlayMessage()}
                </HistoryRecordMiddleSectionBox>
            );
        }
    }
);